import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Form, FormGroup, FormText, Input, Label, Table } from 'reactstrap';
import { GoCheck, GoCircleSlash } from 'react-icons/go';
import { connect } from 'react-redux';

class CounTX extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            tableData: [],
            addResponse: null,
            deleteResponse: null,
            deletedVal: "",
            pcidName: ""
        }
        this.apiFetch("GetCounTX", {}, "tableData")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        if (stateItem != "" && stateItem != null) {
            this.setState({
                [stateItem]: data
            })
        }
        if (stateItem == "") {
            return data
        }

    }

    async addCounselor(e) {
        e.preventDefault();
        const dataInput = new FormData(e.target);
        if (dataInput.get("txid") != "" && dataInput.get("pcid") != ""){
            this.apiFetch("AddCounsTX", { txid: dataInput.get('txid'), pcid: dataInput.get('pcid') },"addResponse")
        }
        this.apiFetch("GetCounTX", {}, "tableData")
        setTimeout(() => {
            this.setState({
                addResponse: null
            })
        }, 4000)
    }

    async deleteCounTX(pk) {
        this.apiFetch("DeleteCounsTX", { txid: pk }, "deleteResponse")
        this.setState({
            deletedVal: pk
        })
        this.apiFetch("GetCounTX", {}, "tableData")
        setTimeout(() => {
            this.setState({
                deleteResponse: null,
                deletedVal: ""
            })
        }, 4000)
    }

    async nameLookup(e) {
        if (e.target.value.length == 10) {
            let name = await this.apiFetch("stuLookupCounselor", { stuPCID: e.target.value }, "")
            this.setState({
                pcidName: name.stuName
            });
        } else {
            this.setState({
                pcidName: ""
            })
        }
    }

    render() {
        return (
            <div>
                <Form className="d-flex" inline onSubmit={this.addCounselor.bind(this)}>
                    <FormGroup>
                        <Label>TargetX ID</Label>
                        <Input type="text" name="txid" id="txid" />
                    </FormGroup>
                    &nbsp;
                    <FormGroup>
                        <Label>PCID</Label>
                        <Input type="text" name="pcid" id="pcid" onChange={this.nameLookup.bind(this)} />
                        <FormText>{this.state.pcidName}</FormText>
                    </FormGroup>
                    &emsp;
                    <Button type="submit" outline color="success">Add</Button>
                    &nbsp;
                    {this.state.addResponse && <GoCheck />}
                    {this.state.addResponse == false && <GoCircleSlash color="#CC482B" />}
                </Form>
                <br />
                <Table striped>
                    <thead>
                        <tr>
                            <th>TargetX ID</th>
                            <th>Name (PCID)</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.tableData.map(data => (
                        <tr>
                            <td>{data.txid}</td>
                            <td>{data.fullname}</td>
                            <td><Button outline color="danger" onClick={() => this.deleteCounTX(data.pk)}>Delete</Button>&nbsp;
                                {this.state.deleteResponse  && data.pk == this.state.deletedVal && <GoCheck />}
                                {this.state.deleteResponse == false && data.pk == this.state.deletedVal && <GoCircleSlash color="#CC482B" />}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(CounTX);